import { Directive, OnDestroy } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Directive()
export class OnDestroyComponent implements OnDestroy {
	protected readonly destroy$ = new Subject<void>();

	subscribe<R>(obs$: Observable<R>) {
		obs$.pipe(takeUntil(this.destroy$)).subscribe();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
